import { put, takeLatest, all } from 'redux-saga/effects'
import { api, exportApi, nodeApi } from '../../service/apiService'
import {
    getDivision, getDistrict, getLocation, getStore,
    getStoreByDistrict, getSearchResultCurrent, getCaseIdForm, exportToExcel,
    getRoleBasedDetails, closeContact, saveNotClosed, positions, contacts, getTotalComments,
    getSubscriptionKey, getUserSFKeyMap, getUserSFKeyValidation, getAccessDetail
} from '../../service/apiUrls';
import { authTokenCookie } from '../../utils/CookieMaker';
import { userRole } from '../../utils/constants'
import { formSelectData, formAutoCompleteData, caseIdFormData, formatDetails } from '../../utils/utils'
import { serviceInProgress } from '../../component/containers/loader/LoaderAction';
import {
    setRole, GET_ROLE, setDetails, GET_DETAILS,
    GET_DIVISION, GET_DISTRICT, GET_STORE, GET_LOCATION,
    setDivision, setDistrict, setStore, setLocation, setStoreByDistrict,
    GET_STORE_DISTRICT, GET_SEARCHRESULT, setSearchResult, GET_EXPORTTOEXCEL, GET_APIMKEY, setAPIMKey,
    GET_USERSFKEYMAP, setUserSFKeyMap, GET_USERSFKEYVALIDATION, GET_ACCESSDETAILS, setAccessDetails, setUserSFKeyValidation
} from '../../component/screens/closeTheLoop/closeTheLoopAction'
import { GET_CASE_ID_FORM, GET_CLOSE_CONTACT, GET_SAVE_NOT_CLOSED, setCaseIdForm, setCloseContact, setSaveNotClosed, setContact, setPosition, GET_CONTACT, GET_POSITION } from '../../component/containers/ctlWebForm/ctlWebFormAction'
import { GET_TOTALCOMMENTS, setTotalComments } from 'component/containers/totalCommentsDetails/totalCommentsDetailsAction'
import { call, select } from 'redux-saga/effects';
import * as selectors from './selectors';
// import {ctlWebData} from '../../utils/constants'
// import { SERVICE_ERROR, SERVICE_EXCEPTION, serviceError, serviceException } from '../../common/ServiceError/ServiceErrorAction';
import { serviceError } from '../../common/ServiceError/ServiceErrorAction';
import { queryBuilder } from '../../utils/utils'

function exceptionFormatter(exp) {
    if (exp.config) {
        return { message: "System is unable to process this request at the moment, please contact the System Administrator." }
    }
    else return { exp, url: ``, method: `` }
}

function isJWTNotExpired() {
    let tokenNotExpired = true;
    let currentDate = new Date();
    let currentTime = currentDate.getTime();
    let { decodedIdToken, authCookie, userInfo } = authTokenCookie();
    // JWT exp is in seconds
    let sessionId = sessionStorage.getItem('sessionId')
    console.log(decodedIdToken.exp * 1000, currentTime, `cookie-currenttime`);
    if (authCookie.name && sessionId === userInfo.userId) {
        let tokenExpiry = decodedIdToken.exp * 1000;
        if (tokenExpiry < currentTime) {
            tokenNotExpired = false;
        }
    }
    return tokenNotExpired;
}

function* get_UserSFKeyMap() {
    try {
        let defaultDivision = [`98`, `96`, `99`, `00`, `97`];
        const { userInfo } = authTokenCookie();
        let userDefData = userInfo ? { "roleUserName": userInfo.userId } : ``;
        userDefData = (userInfo.userDivision && !defaultDivision.includes(userInfo.userDivision)) ? { ...userDefData, "swyDivision": userInfo.userDivision } : userDefData
        userDefData = userInfo && userInfo.userDistrict && Array.isArray(userInfo.userDistrict) ? { ...userDefData, "swyDistrict": userInfo.userDistrict } :
            (userInfo && userInfo.userDistrict ? { ...userDefData, "swyDistrict": [userInfo.userDistrict] } : userDefData)
        userDefData = userInfo && userInfo.userStore && Array.isArray(userInfo.userStore) ? { ...userDefData, "swyFacilityCode": userInfo.userStore } :
            (userInfo && userInfo.userStore ? { ...userDefData, "swyFacilityCode": [userInfo.userStore] } : userDefData);
        if (isJWTNotExpired()) {
            let subKey = yield select(selectors.key);
            let response = yield call(() => { return api(getUserSFKeyMap.url, getUserSFKeyMap.method, userDefData, subKey) });
            let keyMap = response && response.data;
            let modifiedData
            if (keyMap) {
                modifiedData = formatDetails(response.data, response.status)
            }

            yield put(setUserSFKeyMap(modifiedData));
        }
    } catch (exp) {
        console.log(`UserKeyMap Exp`, exp);
    }
}

function* get_UserSFKeyValidation(store) {
    try {
        let defaultDivision = [`98`, `96`, `99`, `00`, `97`];
        const { userInfo } = authTokenCookie();
        let userDefData = userInfo ? { "roleUserName": userInfo.userId } : ``;
        userDefData = (userInfo.userDivision && !defaultDivision.includes(userInfo.userDivision)) ? { ...userDefData, "swyDivision": userInfo.userDivision } : userDefData
        userDefData = userInfo && userInfo.userDistrict && Array.isArray(userInfo.userDistrict) ? { ...userDefData, "swyDistrict": userInfo.userDistrict } :
            (userInfo && userInfo.userDistrict ? { ...userDefData, "swyDistrict": [userInfo.userDistrict] } : userDefData)
        // userDefData = userInfo && userInfo.userStore && Array.isArray(userInfo.userStore) ? { ...userDefData, "swyFacilityCode": userInfo.userStore } :
        //     (userInfo && userInfo.userStore ? { ...userDefData, "swyFacilityCode": [userInfo.userStore] } : userDefData);
        userDefData = { ...userDefData, "swyFacilityCode": [store.storeNo] }
        // userDefData = { ...userDefData, "swyDistrict": [""] }   
        if (isJWTNotExpired()) {
            let subKey = yield select(selectors.key);
            let response
            let keyMap
            if (userDefData.swyDivision) {
                if (userDefData.swyFacilityCode && userDefData.swyFacilityCode[0]) {
                    response = yield call(() => { return api(getUserSFKeyValidation.url, getUserSFKeyValidation.method, userDefData, subKey) });
                    keyMap = response && response.data;
                } else {
                    keyMap = []
                }
            } else {
                keyMap = [userInfo.userRole]
            }
            console.log("statusssss", keyMap)
            // let modifiedData
            // if (keyMap) {
            //     modifiedData = formatDetails(response.data, response.status)
            // }

            yield put(setUserSFKeyValidation(keyMap));
        }
    } catch (exp) {
        console.log(`UserKeyMap Exp`, exp);
    }
}

function* get_SubKey() {
    try {
        let response = yield call(() => { return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method) });
        // let response = yield call(() => { return nodeApi(`https://svwp-ctl-ui-dev.apps.np.stratus.albertsons.com/api/getSubKey`,`GET`) });
        let key = response && response.data && response.data.subKey;
        yield put(setAPIMKey(key));
    }
    catch (exp) {
        console.log(`APIM Key exception`, exp);
    }
};


function* get_division() {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getDivision.url, getDivision.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = formSelectData('Select Division', dataTest.data)
            }
            yield put(setDivision(data))

            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* get_Role() {
    try {
        yield put(serviceInProgress(true));
        const data = userRole;
        yield put(setRole(data))
        yield put(serviceInProgress(false));
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* get_CaseId_Form(caseId) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            // let urlName = caseId.edm ? getCaseIdFormArchive : getCaseIdForm
            // JWTExpirationCheck();
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(`${getCaseIdForm.url}${caseId.payload}`, getCaseIdForm.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = caseIdFormData(dataTest.data);
            }
            // const data = ctlWebData;
            yield put(setCaseIdForm(data))
            if (data)
                yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_Details(role) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let data = yield call(() => { return api(`${getRoleBasedDetails.url}`, getRoleBasedDetails.method, '', subKey) })
            yield put(setDetails(data.data[0]))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_district(divId) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));

            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getDistrict.url + divId.payload, getDistrict.method, '', subKey) })
            let data
            if (dataTest) {
                data = formAutoCompleteData("Select District", dataTest.data)
            }
            yield put(setDistrict(data))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_SearchResult(searchObj) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let url;
            let queryString
            if (searchObj.value.followUpStatus) {
                url = getSearchResultCurrent.url + "/followup"
            }
            else (
                url = getSearchResultCurrent.url + "/nonfollowup"
            )
            let newObj = {
                division_name: searchObj.value.divisionName,
                district_name: searchObj.value.districtId,
                store_id: searchObj.value.storeId,
                location: searchObj.value.location,
                case_id: searchObj.value.contactId,
                from_dt: searchObj.value.fromDt,
                to_dt: searchObj.value.toDt,
                page_number: searchObj.pageNo,
                size_page: searchObj.rowCount,
                field_name: searchObj.fieldName,
                sort_by: searchObj.sortBy,
                escalations_on: searchObj.value.escalations,
                status: searchObj.value.caseStatus
            }
            // queryString = `?${searchObj.value.divisionName=== ""? "":"division_name="+searchObj.value.divisionName}${searchObj.value.districtId === "" ? "" : "&district_name=" + searchObj.value.districtId}${searchObj.value.storeId === "" ? "" : "&store_id=" + searchObj.value.storeId}${searchObj.value.location === "" ? "" : "&location=" + searchObj.value.location}${searchObj.value.contactId === "" ? "" : "&case_id=" + searchObj.value.contactId}&from_dt=${searchObj.value.fromDt}&to_dt=${searchObj.value.toDt}&page_number=${searchObj.pageNo}&size_page=${searchObj.rowCount}&field_name=${searchObj.fieldName}&sort_by=${searchObj.sortBy}&escalations_on=${searchObj.value.escalations}&status=${searchObj.value.caseStatus}`
            queryString = queryBuilder(newObj)
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(url + queryString, getDistrict.method, ``, subKey) })
            yield put(setSearchResult(dataTest))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_ExportToExcel(searchObj) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let url;
            let queryString
            if (searchObj.value.followUpStatus) {
                url = exportToExcel.url + "/followup"
            }
            else (
                url = exportToExcel.url + "/notfollowup"
            )
            let newObj = {
                division_name: searchObj.value.divisionName,
                district_name: searchObj.value.districtId,
                store_id: searchObj.value.storeId,
                location: searchObj.value.location,
                case_id: searchObj.value.contactId,
                from_dt: searchObj.value.fromDt,
                to_dt: searchObj.value.toDt,
                page_number: searchObj.pageNo,
                size_page: searchObj.rowCount,
                field_name: searchObj.fieldName,
                sort_by: searchObj.sortBy,
                escalations_on: searchObj.value.escalations,
                status: searchObj.value.caseStatus
            }
            queryString = queryBuilder(newObj)
            // let queryString = `?division_name=${searchObj.value.divisionName}${searchObj.value.districtId === "" ? "" : "&district_name=" + searchObj.value.districtId}${searchObj.value.storeId === "" ? "" : "&store_id=" + searchObj.value.storeId}${searchObj.value.location === "" ? "" : "&location=" + searchObj.value.location}${searchObj.value.contactId === "" ? "" : "&case_id=" + searchObj.value.contactId}&from_dt=${searchObj.value.fromDt}&to_dt=${searchObj.value.toDt}&size_page=${searchObj.rowCount}&field_name=${searchObj.fieldName}&sort_by=${searchObj.sortBy}&escalations_on=${searchObj.value.escalations}&status=${searchObj.value.caseStatus}`
            //let queryString = `?divisionId=27&districtId=0&storeId=0&fromDt=2022-02-11&toDt=2022-04-12&pageNumber=1&sizePage=25&fieldName=CUSTOMER_CONTACT_ID&sortBy=ASC&escalationsOn=store_manager`;
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return exportApi(url + queryString, exportToExcel.method, ``, subKey) })
            // yield put(setAllSearchResult(dataTest))
            if (dataTest) {
                var blob = new Blob([dataTest.data], { type: 'application/xlsx' });
                var link = document.createElement('a');
                var fileURL = window.URL.createObjectURL(blob);
                link.href = fileURL;
                link.download = `ClosetheLoopComments-${searchObj.value.followUpStatus ? "Followup" : "Not Followup"}${searchObj.value.edm ? "" : searchObj.value.followUpStatus ? `-${searchObj.value.caseStatus} Status` : ""}.xlsx`;
                link.target = '_blank';
                link.click();
                //  return true;
            }
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* get_store(divId) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true))
            let subKey = yield select(selectors.key)
            let dataTest = yield call(() => { return api(getStore.url + divId.payload, getStore.method, '', subKey) })
            let data;
            if (dataTest) {
                data = formAutoCompleteData("Select Store", dataTest.data)
            }
            yield put(setStore(data))
            yield put(serviceInProgress(false))
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false))
        yield put(serviceError(exceptionFormatter(exp)))
    }
}

function* get_store_byDistrict(disId) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getStoreByDistrict.url + disId.payload, getStoreByDistrict.method, '', subKey) })
            let data
            if (dataTest) {
                data = formAutoCompleteData("Select Store", dataTest.data)
            }
            yield put(setStoreByDistrict(data))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)))
    }
}

function* get_location() {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            // JWTExpirationCheck();
            let subKey = yield select(selectors.key);
            // let locURL = (host.includes(`dev`) || host.includes(`localhost`)) ? `dev` : (host.includes(`qa`) ? `qa` : (host.includes(`perf`) ? `perf` : ``));
            let dataTest = yield call(() => { return api(getLocation.url, getLocation.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = formSelectData('Select Location', dataTest.data)
            }
            yield put(setLocation(data))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_TotalComments(caseID) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            // JWTExpirationCheck();
            let subKey = yield select(selectors.key);
            let res = yield call(() => { return api(getTotalComments.url + `?contactId=${caseID.value}`, getTotalComments.method, ``, subKey) })
            yield put(setTotalComments(res?.data?.customerServiceRecords?.[0]))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_AccessDetails(userInfo) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            if (subKey === undefined) {
                // JWTExpirationCheck();
                let response = yield call(() => { return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method) });
                subKey = response && response.data && response.data.subKey;
            }
            // let subKey = yield select(selectors.key);
            //     console.log("keyyyy" , subKey)
            let userNameRole = [];
            if (userInfo?.value?.allUserRole !== null) {
                userInfo?.value?.allUserRole.forEach((userRole, index) => {
                    if (userRole === 'StorePharmacyUser' || userRole === 'StoreUser') {
                        userNameRole.push('StoreUser')
                    } else if (userRole === 'CSCUser' || userRole === 'BackstageNonCSCUser' || userRole === 'SuperAdmin' || userRole === 'AssetProtectionUser') {
                        userNameRole.push('CSCUser')
                    } else {
                        userNameRole.push(userRole)
                    }
                })
            }

            // console.log("🚀 ~ file: index.js:405 ~ function*get_AccessDetails ~ userNameRole:", userNameRole)
            // console.log("🚀 ~ file: index.js:405 ~ function*get_AccessDetails ~ userInfo?.value?.allUserRole:", userInfo?.value?.allUserRole)
            let request = {
                "userNameRole": userInfo?.value?.allUserRole !== null ? userNameRole.join(`;`) : "",
                "userName": userInfo?.value?.userId
            }

            let res = yield call(() => { return api(getAccessDetail.url, getAccessDetail.method, request, subKey) })
            //let res = yield call(() => { return api(getAccessDetail.url, getAccessDetail.method, request) })
            yield put(setAccessDetails(res?.data))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* close_Contact(reqObj) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            // JWTExpirationCheck();
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(`${closeContact.url}${reqObj.caseId}`, closeContact.method, reqObj.value, subKey) })

            yield put(setCloseContact(dataTest))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* save_not_Closed(reqObj) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            // JWTExpirationCheck();
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(`${saveNotClosed.url}${reqObj.caseId}`, saveNotClosed.method, reqObj.value, subKey) })
            yield put(setSaveNotClosed(dataTest))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* get_Contacts() {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            // JWTExpirationCheck();
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(contacts.url, contacts.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = formSelectData('Select Result', dataTest.data)
            }
            yield put(setContact(data))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* get_Positions() {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            // JWTExpirationCheck();
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(positions.url, positions.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = formSelectData('Select Contacting Employee Position', dataTest.data)
            }
            yield put(setPosition(data))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* Watcher() {
    yield takeLatest(GET_APIMKEY, get_SubKey);
    yield takeLatest(GET_ACCESSDETAILS, get_AccessDetails);
    yield takeLatest(GET_USERSFKEYMAP, get_UserSFKeyMap);
    yield takeLatest(GET_USERSFKEYVALIDATION, get_UserSFKeyValidation);
    yield takeLatest(GET_DIVISION, get_division);
    yield takeLatest(GET_DISTRICT, get_district);
    yield takeLatest(GET_STORE, get_store);
    yield takeLatest(GET_STORE_DISTRICT, get_store_byDistrict);
    yield takeLatest(GET_LOCATION, get_location);
    yield takeLatest(GET_ROLE, get_Role);
    yield takeLatest(GET_DETAILS, get_Details);
    yield takeLatest(GET_SEARCHRESULT, get_SearchResult);
    yield takeLatest(GET_EXPORTTOEXCEL, get_ExportToExcel);
    yield takeLatest(GET_CASE_ID_FORM, get_CaseId_Form);
    yield takeLatest(GET_TOTALCOMMENTS, get_TotalComments);
    yield takeLatest(GET_CLOSE_CONTACT, close_Contact);
    yield takeLatest(GET_SAVE_NOT_CLOSED, save_not_Closed);
    yield takeLatest(GET_POSITION, get_Positions);
    yield takeLatest(GET_CONTACT, get_Contacts);


}
// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga() {
    yield all([
        Watcher()])
}
